
import Vue, { PropType } from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { SearchUserObject } from "@/interfaces/shared/auto_complete_user_search";
import { TranslateResult } from "vue-i18n";
import {
  GET_USER_INFO,
  USER_INFO,
  SELECTED_USERS,
  RESET_USERS
} from "@/store/modules/common/constants";
export default Vue.extend({
  name: "AutoCompleteUserSearch",
  data() {
    return {
      selected_searched_user: [] as SearchUserObject[],
      searched_users: [] as SearchUserObject[],
      search_input: null as string | null,
      dropdown_icon: require("@/assets/icons/linear/direction-down.svg")
    };
  },
  computed: {
    ...mapGetters("common", {
      get_user: USER_INFO,
      fetch_users: SELECTED_USERS
    })
  },
  props: {
    hide_details: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String as PropType<TranslateResult>
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.get_user?.length) {
      this.searched_users = this.get_user.map((user: any) => ({
        id: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        label: `${user.first_name} ${user.last_name ? user.last_name : ""}`,
        email: user.email,
        avatar_uri: user.avatar_uri
      }));
    }
    if (this.fetch_users?.length) {
      this.selected_searched_user = this.fetch_users;
    }
  },
  watch: {
    /**
     * Function to Fetch Users on the base of input
     */
    async search_input(value) {
      if (value !== null) {
        const result = await this.autocomplete_user_search(value);
        if (result?.length > 0) {
          const filteredResult = result.filter(
            (item: SearchUserObject) =>
              !this.selected_searched_user?.some(
                (selectedItem: SearchUserObject) => selectedItem?.id === item.id
              )
          );

          this.searched_users = [
            ...this.selected_searched_user,
            ...filteredResult
          ].map((user: any) => ({
            id: user.id,
            first_name: user.first_name,
            last_name: user.last_name,
            label: `${user.first_name} ${user.last_name ? user.last_name : ""}`,
            email: user.email,
            avatar_uri: user.avatar_uri
          }));
        }
        return;
      }
    }
  },
  methods: {
    on_change(value: SearchUserObject[]) {
      this.set_selected_users(value);
      this.$emit("searched_user", value);
    },
    ...mapActions("common", {
      autocomplete_user_search: GET_USER_INFO
    }),
    ...mapMutations("common", {
      set_selected_users: SELECTED_USERS,
      reset_users: RESET_USERS
    }),
    on_clear_selected_users() {
      this.reset_state();
      this.$emit("searched_user", []);
    },
    on_input() {
      this.search_input = null;
    },
    remove_selected_item(id: number) {
      this.selected_searched_user = this.selected_searched_user.filter(
        (item: SearchUserObject) => item.id !== id
      );
      this.$emit("searched_user", this.selected_searched_user);
    },
    reset_state() {
      this.selected_searched_user = [];
      this.searched_users = [];
      this.search_input = null;
      this.reset_users();
    },
    display_name(item: SearchUserObject) {
      return `${item.first_name} ${item.last_name ? item.last_name : ""}`;
    }
  }
});
